<div class="profile">
  @if (profile) {
    <div class="outlet-content">
      <div class="network-header header">
        <div class="network-cover">
          <div class="cover">
            <div class="cover-background">
              <div class="cover-image"></div>
            </div>
          </div>
        </div>
        <div class="logo">
          <div class="relative">
            <app-edit-profile-pic
              [width]="120"
              [profile]="profile"
              [nocache]="nocache"
              (edit)="initUploader(); fileSingle.click()"
              [refreshCount]="refreshCount"
            ></app-edit-profile-pic>
            <input
              accept="image/png, image/jpeg"
              #fileSingle
              class="d-none"
              type="file"
              celoFileSelect
              [uploader]="uploader"
              [multiple]="false"
            />
          </div>
        </div>
        <div class="network-header-content relative">
          <div class="name-line items-center">
            <div class="celo-heading name">
              {{ profile.title }} {{ profile.firstName }} {{ profile.lastName }}
            </div>
            &nbsp;&nbsp;
            <div class="badge-container">
              <app-badge
                [identityVerificationStatus]="
                  profile.identityVerificationStatus
                "
                [workspaces]="profile.workplaces"
                [profession]="profile.professions[0]"
                [size]="28"
                [showTooltip]="false"
                [clickable]="true"
                [ownProfile]="true"
                [name]="profile.firstName + ' ' + profile.lastName"
                [name_verified_as]="
                  profile.legalFirstName + ' ' + profile.lastName
                "
                [title]="profile.title"
                [userId]="profile.userId"
                [hasImage]="!!profile.picture"
              ></app-badge>
            </div>
          </div>
          @if (profile.professions && profile.professions[0]) {
            <div class="subname celo-elipsis-2">
              <div class="text">
                {{ profile.professions[0].profession }}
                @if (
                  profile.professions[0].verificationStatus === "Unverified"
                ) {
                  <span>(Unverified)</span>
                }
              </div>
            </div>
          }
          <div class="oncallbutton">
            <app-oncall-toggle-button
              [userAccount]="profile"
              [height]="34"
              [isOnCall]="isOnCall"
              (isOnCallChange)="isOnCall = $event"
            ></app-oncall-toggle-button>
          </div>
          <div class="share-profile">
            <button
              mat-button
              (click)="
                shareProfile();
                analyticsService.buttonClickEvent(
                  'open_share_profile_from_settings'
                )
              "
            >
              <div>
                <img
                  class="svgIcon"
                  src="../../assets/icons/ic-share.svg"
                  alt=""
                />
                <span class="text">Share profile link</span>
              </div>
            </button>
          </div>
        </div>
      </div>
      <div class="flex">
        <!-- Left content -->
        <div class="profile-box">
          <div
            class="profile-box-content profile-box-content-left personal-info"
          >
            <div class="celo-text-16 card-title">Personal Info</div>
            <div
              mat-ripple
              data-testid="preferred-name-field"
              class="field celo-hoverable celo-cursor-pointer"
              (click)="editPreferredName()"
            >
              <div class="celo-field-title">Preferred Name</div>
              <div class="celo-text-14" data-testid="preferred-name-value">
                {{ profile.firstName ? profile.firstName : "-" }}
              </div>
              <div class="edit-button">
                <button
                  mat-button
                  disableRipple
                  class="celo-tertiary-button no-mat-hover"
                >
                  Edit
                </button>
              </div>
            </div>
            <div
              mat-ripple
              class="field celo-hoverable celo-cursor-pointer"
              (click)="editTitle()"
            >
              <div class="celo-field-title">Title</div>
              <div class="celo-text-14">
                {{ profile.title ? profile.title : "No title" }}
              </div>
              <div class="edit-button">
                <button
                  mat-button
                  disableRipple
                  class="celo-tertiary-button no-mat-hover"
                >
                  Edit
                </button>
              </div>
            </div>
            <div
              mat-ripple
              class="field celo-hoverable celo-cursor-pointer"
              (click)="onEditFullName()"
            >
              <div class="celo-field-title">Full Name</div>
              <div class="celo-text-14">
                {{ profile.legalFirstName }} {{ profile.lastName }}
              </div>
              <div class="edit-button">
                <button
                  mat-button
                  disableRipple
                  class="celo-tertiary-button no-mat-hover"
                >
                  Edit
                </button>
              </div>
            </div>
            <div
              class="field celo-hoverable celo-cursor-pointer"
              (click)="verifyIdentity()"
            >
              <div class="celo-field-title">Identity Verification</div>
              <div class="celo-text-14">
                @if (profile.identityVerificationStatus === "Verified") {
                  <span>Verified</span>
                }
                @if (profile.identityVerificationStatus === "Pending") {
                  <span>Pending</span>
                }
                @if (
                  !profile.identityVerificationStatus ||
                  profile.identityVerificationStatus === "Unverified"
                ) {
                  <span>Unverified</span>
                }
              </div>
              @if (profile.identityVerificationStatus !== "Verified") {
                <div class="celo-text-12 celo-grey celo-link">
                  You can verify your identity using the mobile app.
                </div>
              }
              @if (profile.identityVerificationStatus === "Verified") {
                <div
                  (click)="$event.stopPropagation()"
                  class="celo-text-12 celo-grey"
                >
                  Verified full name not correct? Contact us at
                  <a href="mailto:support@celohealth.com" class="celo-link"
                    >support&#64;celohealth.com</a
                  >
                  and we can update it for you.
                </div>
              }
            </div>
            <div
              class="field celo-hoverable celo-cursor-pointer profession"
              (click)="editOrVerifyProfession()"
            >
              @if (
                !profile.professions ||
                !profile.professions[0] ||
                !profile.professions[0].profession
              ) {
                <button mat-button class="celo-secondary-button">
                  ADD PROFESSION
                </button>
              }
              @if (
                profile.professions &&
                profile.professions[0] &&
                profile.professions[0].profession
              ) {
                <div class="celo-text-14">
                  <div class="celo-field-title">Profession</div>
                  <span>{{ profile.professions[0].profession }}</span>
                  @if (
                    profile.professions[0].verificationStatus === "Verified"
                  ) {
                    <div class="badge" (click)="$event.stopPropagation()">
                      <app-badge
                        [identityVerificationStatus]="'Verified'"
                        [profession]="profile.professions[0]"
                        [workspaces]="profile.workplaces"
                        [size]="20"
                        [showTooltip]="false"
                        [clickable]="true"
                        [ownProfile]="true"
                        [name]="profile.firstName + ' ' + profile.lastName"
                        [name_verified_as]="
                          profile.legalFirstName + ' ' + profile.lastName
                        "
                        [title]="profile.title"
                        [userId]="profile.userId"
                        [hasImage]="!!profile.picture"
                      ></app-badge>
                    </div>
                  }
                  @if (
                    profile.professions[0].verificationStatus === "Pending"
                  ) {
                    <span class="celo-field-title">(Pending)</span>
                  }
                  @if (
                    profile.professions[0].verificationStatus === "Unverified"
                  ) {
                    <span class="celo-field-title">(Unverified)</span>
                  }
                  <div class="edit-button">
                    <button
                      mat-button
                      disableRipple
                      class="celo-tertiary-button no-mat-hover"
                    >
                      Edit
                    </button>
                  </div>
                </div>
              }
            </div>
          </div>
          <div class="profile-box-content profile-box-content-left">
            <div class="celo-text-16 card-title">Location</div>
            <div class="field">
              <div class="celo-text-14">
                {{
                  profile.countryCode
                    ? (profile.countryCode | countryFromCode)
                    : "-"
                }}
              </div>
              <div class="celo-text-12 celo-grey">
                Only you can see your location. To change your location please
                get in touch with us at
                <a href="mailto:support@celohealth.com" class="celo-link"
                  >support&#64;celohealth.com</a
                >
              </div>
            </div>
          </div>
          <div class="profile-box-content profile-box-content-left">
            <div class="celo-text-16 card-title">Contact Info</div>
            <div
              mat-ripple
              class="field celo-hoverable celo-cursor-pointer"
              (click)="getPhone()"
            >
              @if (!profile.phoneNumber) {
                <button mat-button class="celo-secondary-button">
                  ADD A MOBILE NUMBER
                </button>
              }
              @if (profile.phoneNumber) {
                <div>
                  <div class="celo-field-title">Mobile number</div>
                  <app-info-line [title]="profile.phoneNumber"></app-info-line>
                </div>
              }
              @if (profile.phoneNumber) {
                <div class="edit-button">
                  <button
                    mat-button
                    disableRipple
                    class="celo-tertiary-button no-mat-hover"
                  >
                    Edit
                  </button>
                </div>
              }
            </div>
            <div
              mat-ripple
              class="field celo-hoverable celo-cursor-pointer"
              (click)="getEmail()"
            >
              @if (!profile.email) {
                <button mat-button class="celo-secondary-button">
                  ADD A PRIMARY EMAIL
                </button>
              }
              @if (profile.email) {
                <div>
                  <div class="celo-field-title">Primary email</div>
                  <app-info-line [title]="profile.email"></app-info-line>
                </div>
              }
              <div class="edit-button">
                <button
                  mat-button
                  disableRipple
                  class="celo-tertiary-button no-mat-hover"
                >
                  Edit
                </button>
              </div>
              <div class="celo-text-12 celo-grey">
                Use a personal email address so you can recover or login to your
                Celo account even if you move workspaces.
              </div>
            </div>
          </div>
        </div>
        <!-- Right content -->
        <div class="profile-box">
          <!-- Workspace info -->
          <div class="profile-box-content profile-box-content-right">
            <div class="celo-text-16 card-title">Workspace Info</div>
            <div>
              <app-companies-list
                [companies]="companies"
                [responsive]="false"
                [editable]="true"
                (edit)="editCompany($event)"
              ></app-companies-list>
            </div>
            <div class="field">
              <a (click)="joinWorkspace()" class="celo-link celo-bold-500"
                >Join existing workspace</a
              >
            </div>
            <div class="field">
              <a (click)="createWorkspace()" class="celo-link celo-bold-500"
                >Create new workspace</a
              >
            </div>
          </div>
          <!-- Roles info -->
          <!-- <ng-container *ngIf="teams$ | async as teams">
                              <div
                                *ngIf="teams?.length"
                                class="profile-box-content profile-box-content-right"
                                >
                                <div class="celo-text-16 card-title">Roles Info</div>
                                <app-profile-roles-list [teams]="teams"></app-profile-roles-list>
                              </div>
                            </ng-container> -->
        </div>
      </div>
    </div>
  }
  @if (!profile) {
    <div>
      <div class="loading-screen">
        <app-empty-state
          [no_message]="true"
          [isLoading]="true"
          [diameter]="40"
        ></app-empty-state>
      </div>
    </div>
  }
  <div class="version celo-text-14 celo-grey">
    <div>Version {{ version }}</div>
    <app-profile-version-action></app-profile-version-action>
  </div>
</div>
